import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const GoBack = props => {
  return <p className='clickable go-back' onClick={() => props.history.goBack()}><FontAwesomeIcon icon='arrow-circle-left' /></p>
}

export default GoBack